import { getFormattedDate, mangleDateFormatter } from './dateHelpers'

export const getProgramDurationProgress = (
    startMilis: number,
    durationMilis: number
) => {
    const actualDate = Date.now()
    const programStartMilis = mangleDateFormatter(startMilis)
    const programDurationProgress = actualDate - programStartMilis
    const programDuration = durationMilis
    return (programDurationProgress / programDuration) * 100
}

export const getFormattedProgramDuration = (
    startMilis: number,
    endMilis: number
) => {
    const programStartMilis = startMilis
    const programEndsMilis = endMilis
    const formattedStartDate = getFormattedDate(programStartMilis)
    const formattedEndDate = getFormattedDate(programEndsMilis)
    return `${formattedStartDate} - ${formattedEndDate}`
}

export const getFormattedProgramDurationShort = (durationMilis: number) => {
    const programDuration = durationMilis / 60 / 1000
    if (programDuration < 60) {
        return `${programDuration}m`
    } else {
        const hours = Math.floor(programDuration / 60)
        const remainingMinutes = programDuration % 60
        const formattedHours = hours.toString().padStart(2, '0')
        const formattedMinutes = remainingMinutes.toString().padStart(2, '0')
        return `${formattedHours}:${formattedMinutes}h`
    }
}
